import React, { useEffect, useState, useRef, useCallback } from "react";
import useThrottle from './useThrottle';

function useOffsetTop(ref) {
  const [viewportTop, setViewportTop] = useState(undefined);
  const [pageOffsetTop, setPageOffsetTop] = useState(undefined);

  const handler = useThrottle(() => {
    if (!ref.current) return;
    const clientRect = ref.current.getBoundingClientRect();
    setViewportTop(clientRect.top);
    const newPageOffsetTop = clientRect.top + window.pageYOffset;
    setPageOffsetTop(newPageOffsetTop);
  }, 100); // 100msに一度実行


  useEffect(() => {
    if (!ref.current) return;
    
    // マウント時にも実行
    handler();
    window.addEventListener("scroll", handler);
    
    // アンマウント時にイベントリスナーを解除
    return () => window.removeEventListener("scroll", handler);
  }, [handler]);

  return { viewportTop, pageOffsetTop };
}

export default useOffsetTop;
